import * as yup from 'yup';
import { DEVICE_TYPES } from 'commons/models/common';

import { Row, RenderConfig, TextInput, AsyncSelect, ASSET_TYPE_NONS3, AssetUploadInput, SelectInput, CASE } from 'commons-ui';

export const FORM_FIELD_KEYS = {
	DOCUMENT_TYPE: 'documentType',
	NAME: 'name',
	DOCUMENT_NUMBER: 'documentNumber',
	DOB: 'dob',
	KYC_IMAGE: 'frontImage',
	DEVICE_TYPE: 'deviceType'
};

export const validationSchema = yup.object().shape({
	fullName: yup.string().required('name is a required field'),
	documentType: yup.number().required('documentType is a required field'),
	documentNumber: yup.string().required('documentNumber is a required field'),
	dob: yup.number().required('dob is a required field'),
	deviceType: yup.string().required('deviceType is a required field'),
	frontImage: yup.mixed().test('file', 'Kyc file attachment is required', (file) => {
		if (file && file instanceof File) {
			return true;
		}
		return false;
	})
});

const getDeviceTypeOptions = () => {
	const deviceTypeOptions = (Object.keys(DEVICE_TYPES) as Array<keyof typeof DEVICE_TYPES>).map((key) => {
		return { id: DEVICE_TYPES[key], label: key };
	});
	return deviceTypeOptions;
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.NAME]: new RenderConfig()
		.setName('fullName')
		.setLabel('Name on your selected document')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			letterCase: CASE.UPPERCASE
		}),
	[FORM_FIELD_KEYS.DEVICE_TYPE]: new RenderConfig()
		.setName('deviceType')
		.setLabel('Device Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			options: getDeviceTypeOptions()
		}),
	[FORM_FIELD_KEYS.DOCUMENT_NUMBER]: new RenderConfig()
		.setName('documentNumber')
		.setLabel('Number on your selected document')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.DOB]: new RenderConfig()
		.setName('dob')
		.setLabel('Date of Birth')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			inputType: 'date'
		}),
	[FORM_FIELD_KEYS.DOCUMENT_TYPE]: new RenderConfig()
		.setName('documentType')
		.setLabel('Document Type')
		.setRenderer(AsyncSelect)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),

	[FORM_FIELD_KEYS.KYC_IMAGE]: new RenderConfig()
		.setName('frontImage')
		.setLabel('Attach the Document')
		.setRenderer(AssetUploadInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true, assetType: ASSET_TYPE_NONS3.KYC_DOC })
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.DEVICE_TYPE),
	new Row(FORM_FIELD_KEYS.DOCUMENT_TYPE),
	new Row(FORM_FIELD_KEYS.NAME),
	new Row(FORM_FIELD_KEYS.DOCUMENT_NUMBER),
	new Row(FORM_FIELD_KEYS.DOB),
	new Row(FORM_FIELD_KEYS.KYC_IMAGE)
];
